
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar, Heart, Clock, Users } from "lucide-react";

const TestingPhase = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Pourquoi nous sommes en phase de test ?",
      description: "Nous développons activement Legatia avec nos premiers utilisateurs pour créer le meilleur service possible.",
      phases: [
        {
          icon: <Users className="h-6 w-6 text-legatia-orange" />,
          title: "Co-création avec nos utilisateurs",
          description: "Nous adaptons notre service en fonction des retours de nos premiers utilisateurs."
        },
        {
          icon: <Heart className="h-6 w-6 text-legatia-orange" />,
          title: "Amélioration continue",
          description: "Chaque feedback nous aide à affiner l'expérience utilisateur."
        },
        {
          icon: <Clock className="h-6 w-6 text-legatia-orange" />,
          title: "Accès prioritaire",
          description: "Les premiers utilisateurs bénéficient d'avantages exclusifs."
        }
      ]
    },
    en: {
      title: "Why are we in testing phase?",
      description: "We're actively developing Legatia with our first users to create the best possible service.",
      phases: [
        {
          icon: <Users className="h-6 w-6 text-legatia-orange" />,
          title: "Co-creation with users",
          description: "We adapt our service based on early user feedback."
        },
        {
          icon: <Heart className="h-6 w-6 text-legatia-orange" />,
          title: "Continuous improvement",
          description: "Every feedback helps us refine the user experience."
        },
        {
          icon: <Clock className="h-6 w-6 text-legatia-orange" />,
          title: "Priority access",
          description: "Early users get exclusive benefits."
        }
      ]
    },
    de: {
      title: "Warum sind wir in der Testphase?",
      description: "Wir entwickeln Legatia aktiv mit unseren ersten Nutzern, um den bestmöglichen Service zu schaffen.",
      phases: [
        {
          icon: <Users className="h-6 w-6 text-legatia-orange" />,
          title: "Ko-Kreation mit Nutzern",
          description: "Wir passen unseren Service basierend auf frühem Nutzerfeedback an."
        },
        {
          icon: <Heart className="h-6 w-6 text-legatia-orange" />,
          title: "Kontinuierliche Verbesserung",
          description: "Jedes Feedback hilft uns, die Nutzererfahrung zu verfeinern."
        },
        {
          icon: <Clock className="h-6 w-6 text-legatia-orange" />,
          title: "Prioritätszugang",
          description: "Frühe Nutzer erhalten exklusive Vorteile."
        }
      ]
    }
  };

  return (
    <section className="py-24 bg-legatia-orange/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">{content[language].title}</h2>
          <p className="text-xl text-gray-700 mb-12">{content[language].description}</p>
          
          <div className="grid md:grid-cols-3 gap-8">
            {content[language].phases.map((phase, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm">
                <div className="bg-legatia-orange/10 p-3 rounded-full inline-block mb-4">
                  {phase.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{phase.title}</h3>
                <p className="text-gray-600">{phase.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestingPhase;
